import { createContext } from 'react';

export const EventSlotContext = createContext<{
	toggleModal: () => boolean;
}>({
	toggleModal: () => false,
});
